var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSlowStraylightEnclave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slow_BG_-Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6131 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #221b1f;\n      }\n\n      .cls-3 {\n        fill: #1d171a;\n      }\n\n      .cls-4 {\n        fill: #1d171b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.7 1042 1657.39 1042 1750.46 623 1801.76 623 1708.7 1042"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1636.38 1327 1585.07 1327 1428.14 400 1479.45 400 1636.38 1327"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1607.52 1799.57 1556.22 1799.57 1425.33 1610 1476.63 1610 1607.52 1799.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1476.63 1610 1425.33 1610 1481.71 1158 1533.01 1158 1476.63 1610"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1113.91 109 1585.63 369 1708.7 1042 1801.76 623 1838.41 1147 1838.62 1799.57 1607.52 1799.57 1476.63 1610 1533.01 1158 1636.38 1327 1479.45 400 1113.91 109"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1479.45 400 1428.14 400 1062.6 109 1113.91 109 1479.45 400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3707.16 1801.2 3655.86 1801.2 3654.54 1796.25 3705.84 1796.25 3707.16 1801.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3705.84 1796.25 3708 1800.99 3707.16 1801.2 3705.84 1796.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3705.84 1796.25 3654.54 1796.25 3416.13 1271.99 3467.43 1271.99 3705.84 1796.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3467.43 1271.99 3416.13 1271.99 3292.1 1157 3343.4 1157 3467.43 1271.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3252.25 943 3200.95 943 3485.99 600.18 3537.29 600.18 3252.25 943"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3005.11 761 2953.81 761 3016.76 603 3068.06 603 3005.11 761"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2966.57 1801.2 2915.27 1801.2 3020.53 1276 3071.83 1276 2966.57 1801.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3537.29 600.18 3454.28 852 3705.84 1796.25 3467.43 1271.99 3343.4 1157 3253.19 1320 3210.03 1801.2 2966.57 1801.2 3071.83 1276 2846.3 236.99 3005.11 761 3068.06 603 3252.25 943 3537.29 600.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3071.83 1276 3020.53 1276 2795 236.99 2846.3 236.99 3071.83 1276"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2047.19 445 1995.89 445 2097.56 87.08 2148.86 87.08 2047.19 445"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2263.32 1528 2212.02 1528 1909.44 337 1960.74 337 2263.32 1528"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2148.86 87.08 2164.65 499 2271.78 900 2202.24 1085 2497.7 1798.93 2031.63 1798.93 1800.53 1799.43 2149.62 1453 2263.32 1528 1960.74 337 2047.19 445 2148.86 87.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1800.53 1799.43 1749.22 1799.43 2098.31 1453 2149.62 1453 1800.53 1799.43"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4329.71 1461 4278.41 1461 4324.45 1132 4375.75 1132 4329.71 1461"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4305.21 1801 4253.9 1801 4278.41 1461 4329.71 1461 4305.21 1801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4375.75 1132 4324.45 1132 4057.58 943 4108.88 943 4375.75 1132"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4154.92 689 4103.62 689 4013.41 -111 4064.71 -111 4154.92 689"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4252.65 954 4201.35 954 3886.55 341 3937.85 341 4252.65 954"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4064.71 -111 4252.65 260 4171.84 332 4567.45 1190 4435.89 1195 4424.62 1643 4548.66 1801 4305.21 1801 4329.71 1461 4375.75 1132 4108.88 943 4252.65 954 3937.85 341 4154.92 689 4064.71 -111"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5388.74 1799.58 5388.71 1799.08 5388.74 1799.08 5388.74 1799.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5388.74 1799.58 5337.44 1799.58 5337.41 1799.08 5388.71 1799.08 5388.74 1799.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5446.83 1701 5395.52 1701 5326.93 1641.99 5378.23 1641.99 5446.83 1701"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5286.14 784.99 5234.84 784.99 5297.8 341 5349.1 341 5286.14 784.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5242.91 1659.99 5191.61 1659.99 5154.03 869 5205.33 869 5242.91 1659.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5205.33 869 5154.03 869 4881.51 399.99 4932.82 399.99 5205.33 869"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5446.83 1701 5378.23 1641.99 5388.71 1799.08 4922.68 1799.08 5242.91 1659.99 5205.33 869 4932.82 399.99 5230.7 564 5286.14 784.99 5349.1 341 5323.73 1407.99 5446.83 1701"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "4922.68 1799.08 4871.37 1799.08 5191.61 1659.99 5242.91 1659.99 4922.68 1799.08"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "897.43 1801 846.13 1801 645.94 1598 697.24 1598 897.43 1801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "697.24 1598 645.94 1598 560.43 1110 611.73 1110 697.24 1598"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "611.73 1110 560.43 1110 428.86 1028 480.17 1028 611.73 1110"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "390.9 1801 339.6 1801 450.48 1408 501.78 1408 390.9 1801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "431.3 900 380 900 316.1 109 367.41 109 431.3 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "367.41 109 607.96 861 968.81 1218 828.79 1516 1140.87 1801 897.43 1801 697.24 1598 611.73 1110 480.17 1028 545.95 1801 390.9 1801 501.78 1408 209.54 285 431.3 900 367.41 109"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "501.78 1408 450.48 1408 158.23 285 209.54 285 501.78 1408"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5954.24 1799.31 5902.93 1799.31 5725.01 1799 5776.31 1799 5954.24 1799.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5760.34 1638 5709.04 1638 5668.55 1528.37 5719.85 1528.37 5760.34 1638"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5776.31 1799 5725.01 1799 5667.69 1744 5718.99 1744 5776.31 1799"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "5718.99 1744 5667.69 1744 5709.04 1638 5760.34 1638 5718.99 1744"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5719.85 1528.37 5668.55 1528.37 5506.06 493 5557.36 493 5719.85 1528.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "5307.41 191 5256.11 191 5553.99 56 5605.29 56 5307.41 191"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5557.36 493 5506.06 493 5256.11 191 5307.41 191 5557.36 493"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5605.29 56 5464.34 212 5672.01 286 5689.86 1104 5954.24 1799.31 5776.31 1799 5718.99 1744 5760.34 1638 5719.85 1528.37 5557.36 493 5307.41 191 5605.29 56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSlowStraylightEnclave);
export default __webpack_public_path__ + "static/media/bg-slow-straylight-enclave.2fe44ff5efa29ec86561213ee0f23081.svg";
export { ForwardRef as ReactComponent };